<template>
  <div>
    <transition name="fade" mode="out-in">
      <!-- <lottie v-if="!checkAnimationFinished" :options="defaultOptions" :height="400" :width="400" v-on:animCreated="handleAnimation"/> -->
      <div>
        <h1 class="title mqu-subtitle">More information about your results</h1>
        <article class="notification is-light">
          <p class="subtitle is-5">The table below shows the average cost per month (comparison rent) of living in the village and how it varies with your length of stay.</p>
          <table class="table">
            <thead>
            <tr>
              <th>
                <nav class="level">
                  <div class="level-left">
                    Term of Residency (Years)
                  </div>
                  <div class="level-right">
                    <b-tooltip label="This is an average based on your age and gender. Your health may be better or worse than average so your term of residency may differ from this." :multilined="true" :animated="true" type="is-warning">
                      <span class="icon has-text-info">
                        <i class="fas fa-info-circle"></i>
                      </span>
                    </b-tooltip>
                  </div>
                </nav>
              </th>
              <th>Equivalent Monthly Rent</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th><strong>{{value.sorted_response[0].term}}<span v-if="value.sorted_response[0].name === 'expected term'"> (expected term)</span></strong></th>
              <th><strong>{{value.sorted_response[0].rent | currency}}</strong></th>
            </tr>
            <tr>
              <th>{{value.sorted_response[1].term}}<span v-if="value.sorted_response[1].name === 'expected term'"> (expected term)</span></th>
              <th>{{value.sorted_response[1].rent | currency}}</th>
            </tr>
            <tr>
              <th>{{value.sorted_response[2].term}}<span v-if="value.sorted_response[2].name === 'expected term'"> (expected term)</span></th>
              <th>{{value.sorted_response[2].rent | currency}}</th>
            </tr>
            <tr>
              <th>{{value.sorted_response[3].term}}<span v-if="value.sorted_response[3].name === 'expected term'"> (expected term)</span></th>
              <th>{{value.sorted_response[3].rent | currency}}</th>
            </tr>
            <tr>
              <th>{{value.sorted_response[4].term}}<span v-if="value.sorted_response[4].name === 'expected term'"> (expected term)</span></th>
              <th>{{value.sorted_response[4].rent | currency}}</th>
            </tr>
            </tbody>
          </table>
        </article>
      </div>
    </transition>
  </div>
</template>

<script>
import Lottie from 'vue-lottie'
import CheckAnimation from '../../../assets/CheckAnimation'

export default {
  props: ['value', 'loading'],
  components: {
    Lottie
  },
  data() {
    return {
      defaultOptions: { animationData: CheckAnimation, loop: false },
      animationSpeed: 1,
      anim: null,
      showRes: false
    }
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim
    }
  },
  computed: {
    checkAnimationFinished: function() {
      if (this.anim) {
        if (this.anim.isPaused) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/ResultB.vue